import { render, staticRenderFns } from "./HomeResidentsCarousel.vue?vue&type=template&id=a95c1372&scoped=true&"
import script from "./HomeResidentsCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeResidentsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomeResidentsCarousel.vue?vue&type=style&index=0&id=a95c1372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95c1372",
  null
  
)

export default component.exports